import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute, NavigationEnd, Params, PRIMARY_OUTLET } from '@angular/router';
import { filter } from 'rxjs/operators';
import { DataSharingService } from '@EfsServices/data-sharing.service';

interface Breadcrumb {
  label: string;
  params: Params;
  url: string;
}

@Component({
    selector: 'app-breadcrumb',
    templateUrl: './breadcrumb.component.html',
    styleUrls: ['./breadcrumb.component.css'],
    standalone: false
})
export class BreadcrumbComponent implements OnInit {
  public breadcrumbs: Breadcrumb[];

  customBreadcrumbLabel = '';
  showCustomLabel = false;

  constructor(private activatedRoute: ActivatedRoute,
    private router: Router,
    private dataSharingService: DataSharingService) { }

  ngOnInit() {
    this.serviceDataSharing();
    this.breadcrumbs = [];

    // subscribe to the NavigationEnd event
    this.router.events.pipe(filter(event => event instanceof NavigationEnd)).subscribe(event => {
      const root: ActivatedRoute = this.activatedRoute.root;

      // set breadcrumbs
      this.breadcrumbs = this.getBreadcrumbs(root);
      // console.log(JSON.stringify(this.breadcrumbs));
    });
  }

  // services
  serviceDataSharing() {
    this.dataSharingService.observableItem$.subscribe(message => {
      // console.log(message);
      if (message === 'setCustomBreadcrumb') {
        this.customBreadcrumbLabel = sessionStorage.getItem('clientNm');
        this.showCustomLabel = true;
      } else {
        this.showCustomLabel = false;
      }
    });
  }
  // endofservices

  fromBreadcrumb(breadcrumbLabel: string) { // send signal that a breadcrumb link was clicked
    if (breadcrumbLabel === 'Setup') {
      this.dataSharingService.shareData('updateHelp');
    } else {
      this.dataSharingService.shareData(breadcrumbLabel);
    }
    // this.dataSharingService.shareData('updateHelp');
    console.log(breadcrumbLabel);
  }

  private getBreadcrumbs(route: ActivatedRoute, url: string = '', breadcrumbs: Breadcrumb[] = []): Breadcrumb[] {
    const ROUTE_DATA_BREADCRUMB = 'breadcrumb';

    // get the child routes
    const children: ActivatedRoute[] = route.children;

    // return if there are no more children
    if (children.length === 0) {
      return breadcrumbs;
    }

    // iterate over each child
    for (const child of children) {
      if (child.outlet !== PRIMARY_OUTLET) {
        continue;
      }

      // verify the custom data property "breadcrumb" is specified on the route
      if (!child.snapshot.data.hasOwnProperty(ROUTE_DATA_BREADCRUMB)) {
        return this.getBreadcrumbs(child, url, breadcrumbs);
      }

      // get the route's url segment
      const routeURL: string = child.snapshot.url.map(segment => segment.path).join('/');

      // append route URL to URL
      url += `/${routeURL}`;

      // add breadcrumb
      const breadcrumb: Breadcrumb = {
        label: child.snapshot.data[ROUTE_DATA_BREADCRUMB],

        params: child.snapshot.params,

        url
      };
      if (breadcrumb.label !== '') {
        breadcrumbs.push(breadcrumb);
      }

      // breadcrumbs.push(breadcrumb);

      // recursive
      return this.getBreadcrumbs(child, url, breadcrumbs);
    }
  }

  updateHelp() {
    this.dataSharingService.shareData('updateHelp');
  }

}
